import React from 'react';
import { enumValue } from '~/util';
import { usePatientService } from '~/services';
import { Notes } from '../Notes';

interface RiskGapNotesProps {
    entityId: number;
    patientId: number;
}
export function RiskGapNotes({ entityId, patientId }: RiskGapNotesProps) {
    const { updateRiskGap } = usePatientService();

    async function addNote(note: NewNoteType) {
        await updateRiskGap(entityId, patientId, note);
    }

    return (
        <Notes
            addNote={addNote}
            entityId={entityId}
            noteEntity="risk_gap.id"
            noteType={enumValue(['note', 'type', 'Risk Gap Note']) as number}
        />
    );
}
